// test1001
(1001 && 0);
